// components/Modal/Modal.tsx
import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Box,
  Typography,
} from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';
import { modalStyles } from './Modal.styles';
import { ModalProps } from '../../../types/services.types';


const Modal: React.FC<ModalProps> = ({ isOpen, onClose, title, children }) => {
  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      sx={modalStyles.dialog}
    >
      <DialogTitle sx={modalStyles.title}>
        <Box sx={modalStyles.titleContainer}>
          <Typography variant="h6" component="h2">
            {title}
          </Typography>
          <IconButton
            onClick={onClose}
            sx={modalStyles.closeButton}
            aria-label="close"
          >
            <CloseIcon />
          </IconButton>
        </Box>
      </DialogTitle>
      <DialogContent sx={modalStyles.content}>
        {children}
      </DialogContent>
    </Dialog>
  );
};

export default Modal;